const sobMapping = {
  SOURCE_DESTINATION_TRANSPORTER_VEHICLETYPE: {
    type: ['source', 'destination', 'transporter', 'vehicle_type'],
    header_mappings: {
      Source: 'source',
      Destination: 'destination',
      'Transporter Name': 'transporter_name',
      'Transporter Reference Id': 'transporter_reference_id',
      'Vehicle Type': 'vehicle_type',
    },
  },
  SOURCE_DESTINATION_TRANSPORTER: {
    type: ['source', 'destination', 'transporter'],
    header_mappings: {
      Source: 'source',
      Destination: 'destination',
      'Transporter Name': 'transporter_name',
      'Transporter Reference Id': 'transporter_reference_id',
    },
  },
  TRANSPORTER: {
    type: [ 'transporter' ],
    header_mappings: {
      'Transporter Name': 'transporter_name',
      'Transporter Reference Id': 'transporter_reference_id',
    },
  },
  TRANSPORTER_VEHICLETYPE: {
    type: ['transporter', 'vehicle_type'],
    header_mappings: {
      'Transporter Name': 'transporter_name',
      'Transporter Reference Id': 'transporter_reference_id',
      'Vehicle Type': 'vehicle_type',
    },
  },
  SOURCE_TRANSPORTER: {
    type: ['source', 'transporter'],
    header_mappings: {
      Source: 'source',
      'Transporter Name': 'transporter_name',
      'Transporter Reference Id': 'transporter_reference_id',
    },
  },
  DESTINATION_TRANSPORTER: {
    type: ['destination', 'transporter'],
    header_mappings: {
      Destination: 'destination',
      'Transporter Name': 'transporter_name',
      'Transporter Reference Id': 'transporter_reference_id',
    },
  },
  SOURCE_TRANSPORTER_VEHICLETYPE: {
    type: ['source', 'transporter', 'vehicle_type'],
    header_mappings: {
      Source: 'source',
      'Transporter Name': 'transporter_name',
      'Transporter Reference Id': 'transporter_reference_id',
      'Vehicle Type': 'vehicle_type',
    },
  },
  DESTINATION_TRANSPORTER_VEHICLETYPE: {
    type: ['destination', 'transporter', 'vehicle_type'],
    header_mappings: {
      Destination: 'destination',
      'Transporter Name': 'transporter_name',
      'Transporter Reference Id': 'transporter_reference_id',
      'Vehicle Type': 'vehicle_type',
    },
  },
  logic: {
    EVENTUAL_CONSISTENCY: 'eventual_consistency',
    IMMEDIATE_CONSISTENCY: 'immediate_consistency',
  },

};

module.exports = { sobMapping };
